// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"3b0f0b86","349":"c7e88f3b","453":"4b5333ed","569":"776a779a","683":"f3c3ed26","713":"27f9ff79","840":"77bbe788","916":"61c8d56d"}[chunkId] + ".chunk.js";
};